<template>
	<div id="AssistantEdit" class="assistant-edit">
		<div class="container">
			<div>
				<div class="form-group row">
					<label for="inputUrl" class="col-sm-2 col-form-label">URL</label>
					<div class="col-sm-10">
						<input type="text" class="form-control form-control-sm" id="inputUrl" v-model="objectAssistant.url">
					</div>
				</div>
				<div class="form-group row">
					<label for="inputApiKey" class="col-sm-2 col-form-label">Api KEY</label>
					<div class="col-sm-10">
						<input type="text" class="form-control form-control-sm" id="inputApiKey" v-model="objectAssistant.api_key">
					</div>
				</div>
				<div class="form-group row">
					<label for="inputModel" class="col-sm-2 col-form-label">Modelo</label>
					<div class="col-sm-10">
						<input type="text" class="form-control form-control-sm" id="inputModel" v-model="objectAssistant.model">
					</div>
				</div>
				<div class="form-group row">
					<label for="inputInitialMessage" class="col-sm-2 col-form-label">Mensaje Inicial ({{ objectAssistant.initial_message.length }})</label>
					<div class="col-sm-10">
						<textarea class="form-control form-control-sm" id="inputInitialMessage" v-model="objectAssistant.initial_message"></textarea>
					</div>
				</div>
				<div class="text-right">
					<button class="btn btn-primary btn-sm" @click="saveAssistantLocal" :disabled="disabledBtnSaveAssistant">Guardar</button>
				</div>
			</div>
			<hr>
			<list-assistant-action-component ref="listAssistantAction" :assistantId="id"></list-assistant-action-component>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import assistant from '@/mixins/generals/assistant.js'

import ListAssistantActionComponent from '@/components/ListAssistantActionComponent.vue'

export default {
	name: 'AssistantEdit',
	mixins: [axiosAction, errors, mixin, assistant],
	props: ['id'],
	data() {
		return {
		}
	},
	components: {
		'list-assistant-action-component': ListAssistantActionComponent,
	},
	computed: {
		disabledBtnSaveAssistant() {
			return this.savingAssistant
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Buscando el Asistente con el ID ' + this.id)
			this.setSubTitleModule('')
			this.showAssistantLocal()
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'saveAssistantResult': this.saveAssistantResult(response); break;
				case 'showAssistantResult': this.showAssistantResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
        },
		saveAssistantLocal() {
			this.saveAssistant()
		},
		saveAssistantResultLocal(response) {

		},
		showAssistantLocal() {
			if(this.id > 0) {
				this.showAssistant(this.id)
			}
		},
		showAssistantResultLocal(reponse) {
			if(this.objectAssistant.id > 0) {
				this.setTitleModule('Assisten ' + this.objectAssistant.name + ' #' + this.objectAssistant.id)
				setTimeout(() => { this.$refs.listAssistantAction.$refs.btnGetAssistantActionByAssistantId.click() }, 100)
				
			}
		},
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>